import Layout from "@/layout"

const osBspRouter = {
    path: "/generator",
    component: Layout,
    redirect: "noRedirect",
    name: "OS & BSP Generator",
    meta: {
        title: "OS & BSP Generator",
        icon: "excel"
    },
    children: [
        {
            path: "osporting",
            component: () => import("@/views/generator/OsPorting"),
            name: "OS Porting",
            meta: {
                title: "OS Porting",
            }
        },
        {
            path: "bspgenerator",
            component: () => import("@/views/generator/BspGenerator"),
            name: "BSP Generator",
            meta: {
                title: "BSP Generator",
            }
        },
        {
            path: "middleware",
            component: () => import("@/views/generator/Middleware"),
            name: "Middleware",
            meta: {
                title: "Middleware",
            }
        },
        {
            path: "pinout",
            component: () => import("@/views/pinout/Pinout"),
            name: "Pinout",
            meta: {
                title: "Pinout",
            }
        }
    ]
}

export default osBspRouter